import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model"
import { ExpedienteSummaryDto } from "@models/expediente/expedienteSummary.model"

export class UpdateExpedienteVinculadoRequest  extends UpdateKeyValueRequest{
 public idExpedienteVinculado!: number
  public idExpediente!: number
}
